/**
 * Retrieves dictionaries containing property aliases, multiples, and transforms
 * for various styling props.
 * @returns An object containing aliases, multiples, and transforms.
 */
function getParserDicts(allProps) {
  const aliases = {};
  const multiples = {};
  const transforms = {};
  allProps.propNames.forEach(propName => {
    var _config$transform, _config$properties;
    const config = allProps.config[propName];
    if (!config) {
      return;
    }
    if (config.properties) {
      multiples[propName] = [...config.properties];
    }
    if (config.transform && ((_config$transform = config.transform) === null || _config$transform === void 0 ? void 0 : _config$transform.name) !== 'getValue') {
      transforms[propName] = config.transform;
    }
    if (config.property && propName !== config.property || !config.property && !((_config$properties = config.properties) !== null && _config$properties !== void 0 && _config$properties.includes(propName))) {
      aliases[propName] = config.property;
    }
  });
  return {
    aliases,
    multiples,
    transforms
  };
}

export { getParserDicts };
